import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ResultsStrip } from "./components/ResultsStrip";
import { LogoTicker } from "./components/LogoTicker";
import { FormatsSection } from "./components/FormatsSection";
import { ShortClips } from "./components/ShortClips";
import { Work } from "./components/Work";
import { Process } from "./components/Process";
import { Testimonial } from "./components/Testimonial";
import { FAQs } from "./components/FAQs";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { PolicyPage } from "./components/PolicyPage";
import { POLICIES } from "./constants/policies";
import "./styles/base.css";

export default function App() {
    const policy = POLICIES[
        Object.keys(POLICIES).find(
            (key) => POLICIES[key].path === window.location.pathname
        )
    ];

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return undefined;
        }
        const lenis = new Lenis({ lerp: 0.1 });
        window.__lenis = lenis;
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    if (policy) {
        return <PolicyPage policy={policy} />;
    }

    return (
        <>
            <Navbar />
            <main>
                <Hero />
                <ResultsStrip />
                <LogoTicker />
                <Work />
                <FormatsSection />
                <ShortClips />
                <Process />
                <Testimonial />
                <FAQs />
                <FinalCta />
            </main>
            <Footer />
        </>
    );
}
